import React, { useState } from "react";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import { SimuladorIncentivosRRiego } from "./SimuladorIncentivosRRiego";
import { SimuladorIncentivosRRefacciones } from "./SimuladorIncentivosRRefacciones";


const SimuladorIncentivosSistemasRiegoScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
        sucursal: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const rangoSistemasRiego = [
        { minimo: 0, maximo: 79.99, porcentaje_proyectos: 0.0150, porcentaje_productos: 0.0110 },
        { minimo: 80, maximo: 89.99, porcentaje_proyectos: 0.0170, porcentaje_productos: 0.0130 },
        { minimo: 90, maximo: 99.99, porcentaje_proyectos: 0.0190, porcentaje_productos: 0.0150 },
        { minimo: 100, maximo: 109.99, porcentaje_proyectos: 0.0230, porcentaje_productos: 0.0190 },
        { minimo: 110, maximo: 119.99, porcentaje_proyectos: 0.0250, porcentaje_productos: 0.0210 },
        { minimo: 120, maximo: 150000, porcentaje_proyectos: 0.0270, porcentaje_productos: 0.0230 },
    ]

    return (
        <>
            <div className="simulador-incentivo-sin-incentivo-total ">
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BathroomIcon sx={{ fontSize: "18px" }} /> Sistemas de Riego
                    </div>
                    <SimuladorIncentivosRRiego
                        rango={rangoSistemasRiego}
                    />
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosSistemasRiegoScreen;
